export default "__VITE_ASSET__Jh86xn4f__"